import { App, URLOpenListenerEvent } from '@capacitor/app';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { useEffect } from 'react';

const AppUrlListener = () => {
  const navigate = useLocalizedNavigate();
  useEffect(() => {
    let removeListener: (() => void) | undefined;

    if (App.addListener) {
      (async () => {
        removeListener = (
          await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            const slug = event.url.split('.withlocals.com').pop();
            if (slug) {
              navigate(slug);
            }
          })
        ).remove;
      })();
    }

    return () => {
      if (removeListener) {
        removeListener();
      }
    };
  }, [navigate]);

  return null;
};

export default AppUrlListener;
